import axios  from 'axios';

const Log = {
    log: (level, type, source, message, context = {})=> {
        const payload = {
            level: level || "",
            type: type || "",
            source: source || "",
            message: message || "",
            context: context || {}
        };

        axios.post("/api/logs", payload)
            .then(() => console.log(`Log sent: ${level} - ${type}`))
            .catch(error => {
                    console.error(`Error: Failed to send log: ${error.message}. `);
                    console.error(`If you see this, please contact Forestree support with the error above.`)
                }
            );
    },
    info: (type, source, message, context = {}) => {
        Log.log('info', type, source, message, context);
    },
    warn: (type, source, message, context = {}) => {
        Log.log('warn', type, source, message, context);
    },
    error: (type, source, message, context = {}) => {
        Log.log('error', type, source, message, context);
    }

}

export default Log;